var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useQuery } from '@0g/react';
import * as React from 'react';
import { List, ListItem } from './components/List';
import { useStore } from './useStore';
import shallow from 'zustand/shallow';
export function EntityList(_a) {
    var allEntities = useQuery([]);
    var _b = __read(useStore(function (s) { return [s.selectedEntityId, s.api.selectEntity]; }, shallow), 2), selectedId = _b[0], select = _b[1];
    return (React.createElement(List, { css: { width: '100%' } }, allEntities.map(function (entityId) { return (React.createElement(ListItem, { as: "button", key: entityId, state: entityId === selectedId ? 'selected' : 'default', onClick: function () { return select(entityId); } }, entityId)); })));
}
//# sourceMappingURL=EntityList.js.map